// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_BuscaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /so/orders/busca?q={term}
 *
 * Single free-text search term, read from the query string.
 *
 * Fields:
 *   q — string, optional (the search term; min-length is enforced in the
 *       controller so a short/empty term returns an empty result set rather
 *       than a validation error)
 */
import { registerContract } from './validate'

export interface Orders_BuscaInput {
q?: string
}

registerContract('Orders_BuscaInput', {
  q: { type: 'string',  required: false },
})
